<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    :title="$t('userCenter.changePassword')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="400px"
    class="dialog-visible"
    :append-to-body="true"
    :show-close="!showClose"
  >
    <el-form
      ref="formRef"
      label-position="top"
      :rules="formRules"
      :model="formData"
    >
      <p class="password-ruletip">
        <span>密码中应包含大写字母、小写字母、数字、特殊字符其中{{passWordTypeNum}}种字符；</span>
        <span>密码长度不应小于{{passWordLenthLeast}}位；</span>
        <span>密码最长每{{passWordCycle}}天应更改一次；</span>
        <span>密码更改是不得与前{{passWordLoop}}个密码重复使用。</span>
      </p>
      <el-form-item label="输入登录密码" prop="oldPassword">
        <el-input
          v-model="formData.oldPassword"
          type="password"
          placeholder="请输入登录密码"
          autocomplete="off"
        />
      </el-form-item>
      <el-form-item label="输入新密码" prop="newPassword">
        <el-input
          v-model.trim="formData.newPassword"
          type="password"
          placeholder="请输入新密码"
          autocomplete="off"
        />
      </el-form-item>
      <el-form-item label="重复新密码" prop="checkNewPassword">
        <el-input
          v-model.trim="formData.checkNewPassword"
          type="password"
          placeholder="请输入"
          autocomplete="off"
        />
      </el-form-item>
    </el-form>
    <div  slot="footer" class="dialog-footer">
      <el-button v-if="!showClose" plain @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
      <el-button type="primary" :loading="loading" @click="changePassword">
        {{ $t("public.confirm") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { rulesRequired, rulesCheckTwoField } from "@/utils";
import user from "@/api/user/user";
import JSEncrypt from "jsencrypt";
import otherUser from "@/api/other/user";
import { getParameterConfig } from "@/api/common";
export default {
  name: "ChangePassword",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    const checkPassword = (rule, value, callback) => {
      rulesCheckTwoField({ rule, value, callback, checkVal: this.formData.newPassword });
    };
    return {
      passWordTypeNum: 3,
      passWordLenthLeast: 8,
      passWordCycle: 180,
      passWordLoop: 3,
      formKey: new Date().getTime(),
      formData: {
        oldPassword: "",
        newPassword: "",
        checkNewPassword: ""
      },
      formRules: {
        oldPassword: [
          rulesRequired({ message: "请输入登录密码" })
        ],
        newPassword: [rulesRequired({ message: "请输入新密码" })],
        checkNewPassword: [
          rulesRequired({ message: "请输入" }),
          { validator: checkPassword, trigger: ["change", "blur"] }
        ]
      },
      loading: false,
      publicKey: undefined
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  created() {
    this.initPublicKey();
    this.getPassWordTypeNum();
    this.getPassWordLenthLeast();
    this.getPassWordCycle();
    this.getPassWordLoop();
  },
  methods: {
    // 初始化公钥
    initPublicKey() {
      otherUser.getPublicKey().then(res => {
        const { data } = res;
        this.publicKey = data;
      });
    },
    changePassword() {
      // 公钥不存在
      if (!this.publicKey) {
        this.$message.error(this.$t("login.publicKeyError"));
        return;
      }
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // 判断字符含有几种
          const hasChineseLetter = /(?=.*[\u4e00-\u9fa5])/;
          if (hasChineseLetter.test(this.formData.newPassword)) {
            this.$message.error(`密码中应包含大写字母、小写字母、数字、特殊字符其中${this.passWordTypeNum}种字符`);
            return;
          }
          if (this.ruleCheck() < this.passWordTypeNum) {
            this.$message.error(`密码中应包含大写字母、小写字母、数字、特殊字符其中${this.passWordTypeNum}种字符`);
            return;
          }
          if (this.formData.newPassword.length < this.passWordLenthLeast) {
            this.$message.error(`密码长度不应小于${this.passWordLenthLeast}位`);
            return;
          }
          const encryptJs = new JSEncrypt();
          encryptJs.setPublicKey(this.publicKey);
          const { userInfo } = this.$store.state.user;
          const params = {
            authenticatedBy: "password",
            newPassword: encryptJs.encrypt(this.formData.newPassword),
            options: {
              id: userInfo.id,
              oldPassword: encryptJs.encrypt(this.formData.oldPassword)
            },
            passwordEncrypted: true
          };
          user.changePassword(params).then(() => {
            this.$message.success("修改密码成功");
            this.dialogVisible = false;
            this.logoutEDM();
          });
        }
      });
    },
    ruleCheck() {
      const hasUperLetter = /(?=.*[A-Z])/;
      const hasLowerLetter = /(?=.*[a-z])/;
      const hasNumber = /(?=.*[0-9])/;
      const hasSpecial = /(?=.*[`!.@~#$%^&*()_+{}|:"<>?·\！¥……（）——=「」【】｜、\\：；‘’“”《》，。/-;])/;
      let init = 0;
      if (hasLowerLetter.test(this.formData.newPassword)) {
        init += 1;
      };
      if (hasUperLetter.test(this.formData.newPassword)) {
        init += 1;
      };
      if (hasNumber.test(this.formData.newPassword)) {
        init += 1;
      };
      if (hasSpecial.test(this.formData.newPassword)) {
        init += 1;
      };
      return init;
    },
    async logoutEDM() {
      await this.$store.dispatch("user/logout");
      this.$router.push({ path: "/login" });
    },
    getPassWordTypeNum() {
      getParameterConfig("PASSWORD_CHARACTER_KINDS").then(res => {
        if (res.success && res.data) {
          this.passWordTypeNum = res.data.configValue;
        }
      });
    },
    getPassWordLenthLeast() {
      getParameterConfig("PASSWORD_LENGTH").then(res => {
        if (res.success && res.data) {
          this.passWordLenthLeast = res.data.configValue;
        }
      });
    },
    getPassWordCycle() {
      getParameterConfig("PASSWORD_CHANGE_DAYS").then(res => {
        if (res.success && res.data) {
          this.passWordCycle = res.data.configValue;
        }
      });
    },
    getPassWordLoop() {
      getParameterConfig("PASSWORD_NOT_REPEAT_TIMES").then(res => {
        if (res.success && res.data) {
          this.passWordLoop = res.data.configValue;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.password-ruletip{
    padding-bottom: 8px;
    color:#999;
    font-size: 12px;
}
.dialog-footer{
    margin-top:0 !important;
}
</style>
